import { BlockTimeType, BOOKING_TYPE, BookingDto, StatusHistory } from './../definition/booking.dto'
import { BlockOffEmployee, ServiceCategoryDto, ServiceDto } from '../definition'
import moment, { Moment } from 'moment'
import { getDayNumberFromString } from './datetime'

export const getMainCategoryByBookingType = ({
  listMain = [],
  listSub = [],
  listChild = [],
  listServices = [],
  bookingType
}: {
  listMain: ServiceCategoryDto[]
  listSub: ServiceCategoryDto[]
  listChild: ServiceCategoryDto[]
  listServices: ServiceDto[]
  bookingType: BOOKING_TYPE
}) => {
  const servicesByBookingType = listServices.filter((service) => service.bookingType === bookingType)
  const hashServicesByBookingType = Object.fromEntries(servicesByBookingType.map((item) => [item.categoryId, item]))

  const uniqueChildOfService = [
    ...new Map(
      listChild.filter((item) => hashServicesByBookingType[item.id]).map((item) => [item['id'], item])
    ).values()
  ]

  const hashUniqueChildOfService = Object.fromEntries(uniqueChildOfService.map((item) => [item.parentId, item]))

  const uniqueSubCategoryOfChild = [
    ...new Map(listSub.filter((item) => hashUniqueChildOfService[item.id]).map((item) => [item['id'], item])).values()
  ]

  const hashUniqueSubOfChild = Object.fromEntries(uniqueSubCategoryOfChild.map((item) => [item.parentId, item]))

  const uniqueMainCategoryOfSub = [
    ...new Map(listMain.filter((item) => hashUniqueSubOfChild[item.id]).map((item) => [item['id'], item])).values()
  ]

  return uniqueMainCategoryOfSub
}

export const getLastestUpdateTime = (bookingHistory?: StatusHistory, taskHistory?: StatusHistory) => {
  const total = { ...bookingHistory, ...taskHistory }
  const timeFromLatest = Object.values(total).sort((a, b) => {
    return new Date(a).getTime() > new Date(b).getTime() ? -1 : 1
  })
  return timeFromLatest[0] ? moment(timeFromLatest[0]).format('DD-MM-YYYY HH:mm') : ''
}

export const checkIsBlockWorkDay = (blockOffTimes: BlockOffEmployee[], dayIndex: number, weekStart: string) => {
  let foundBlock: BlockOffEmployee | undefined = undefined
  const index = dayIndex === 7 ? 0 : dayIndex
  const day = moment(weekStart).add(index, 'day').format('YYYY-MM-DD')
  let isBlock = false
  blockOffTimes.forEach((block) => {
    const isIgnore = (block.ignoreDays || []).includes(moment(day).format('YYYY-MM-DD'))

    if (
      block.type === BlockTimeType.Recurring &&
      getDayNumberFromString(block.dayOfWeek as string) === dayIndex &&
      !isIgnore
    ) {
      isBlock = true
      foundBlock = block
    }

    if (block.type === BlockTimeType.Once && block.date === day) {
      isBlock = true
      foundBlock = block
    }
  })

  return { isBlock, block: foundBlock ? (foundBlock as BlockOffEmployee) : undefined }
}

export const checkIsBlockDaily = (blockOffTimes: BlockOffEmployee[], date: Moment) => {
  let isBlock = false
  let foundBlock: BlockOffEmployee | undefined = undefined
  const day = date.get('day') === 0 ? 7 : date.get('day')

  blockOffTimes.forEach((block) => {
    const isIgnore = (block.ignoreDays || []).includes(moment(day).format('YYYY-MM-DD'))
    if (
      !block.begin &&
      !block.end &&
      block.type === BlockTimeType.Recurring &&
      getDayNumberFromString(block.dayOfWeek) === day &&
      !isIgnore
    ) {
      isBlock = true
      foundBlock = block
    }

    if (!block.begin && !block.end && block.type === BlockTimeType.Once && block.date === date.format('YYYY-MM-DD')) {
      isBlock = true
      foundBlock = block
    }
  })

  return { isBlock, block: foundBlock ? (foundBlock as BlockOffEmployee) : undefined }
}

export const checkIsBlockDailyPartial = (blockOffTimes: BlockOffEmployee[], hour: number, date: Moment) => {
  let isBlock = false
  let foundBlock: BlockOffEmployee | undefined = undefined
  let duration = 0
  let positionLeft = 0
  const day = date.get('day') === 0 ? 7 : date.get('day')
  blockOffTimes.forEach((block) => {
    const isIgnore = (block.ignoreDays || []).includes(moment(date).format('YYYY-MM-DD'))
    if (
      block.begin &&
      block.end &&
      moment(block.begin, 'hh:mmA').get('hour') === hour &&
      block.type === BlockTimeType.Recurring &&
      getDayNumberFromString(block.dayOfWeek) === day &&
      !isIgnore
    ) {
      const diff = moment.duration(moment(block.end, 'hh:mmA').diff(moment(block.begin, 'hh:mmA'))).asMinutes() / 60
      const startTime = moment(block.begin, 'hh:mmA')
      const left = (startTime.minutes() / 60) * 100
      if (diff > 0) {
        duration = diff
        isBlock = true
        foundBlock = block
        positionLeft = left
      }
    }

    if (
      block.begin &&
      block.end &&
      moment(block.begin, 'hh:mmA').get('hour') === hour &&
      block.type === BlockTimeType.Once &&
      block.date === date.format('YYYY-MM-DD')
    ) {
      const diff = moment.duration(moment(block.end, 'hh:mmA').diff(moment(block.begin, 'hh:mmA'))).asMinutes() / 60

      const startTime = moment(block.begin, 'hh:mmA')
      const left = (startTime.minutes() / 60) * 100
      if (diff > 0) {
        duration = diff
        isBlock = true
        foundBlock = block
        positionLeft = left
      }
    }
  })

  return { isBlock, duration, block: foundBlock ? (foundBlock as BlockOffEmployee) : undefined, positionLeft }
}

export const renderAddress = (address: (string | undefined)[]) => {
  return address.filter((address) => Boolean(address)).join(', ')
}

export const getBookingLabel = (bookingType?: BOOKING_TYPE) => {
  if (bookingType === BOOKING_TYPE.ONE_TIME) {
    return 'Onetime Booking'
  } else if (bookingType === BOOKING_TYPE.RECURRING) {
    return 'Contract Booking'
  } else if (bookingType === BOOKING_TYPE.RECURRING2) {
    return 'Recurring Booking'
  } 
}

export const redirectToBookingDetail = (bookingId?: string,bookingType?: BOOKING_TYPE) => {
  if (bookingType === BOOKING_TYPE.ONE_TIME) {
    return `/schedule/one-time-booking?bookingId=${bookingId}`
  } else if (bookingType === BOOKING_TYPE.RECURRING) {
    return `/schedule/contract-booking?bookingId=${bookingId}`
  } else if (bookingType === BOOKING_TYPE.RECURRING2) {
    return `/schedule/recurring-booking?bookingId=${bookingId}`
  } 
}
